import { useContext } from 'react';
import { SidebarContext } from '../context/SidebarContext';

export const useSidebar = () => {
    const context = useContext(SidebarContext);

    if (!context) {
        // Fallback for components outside the provider or if we haven't wrapped App yet
        return { isOpen: true, toggleSidebar: () => { } };
    }

    return context;
};
